import React, { useState } from "react";
import { Form, Formik, FormikValues } from "formik";
import { Button, Col, Row } from "antd";
import InputField from "../../../shared/components/InputField";
import { reportMacroFormValidation } from "./reportMacroFormValidation";
import { ReportMacro } from "../../../models/ReportMacro/reportMacro.model";
import ReportMacroService from "../../../services/ReportMacro/reportMacro.service";
import { UserRoleEnum } from "../../../enums/userRole.enum";
import AuthContainer from "../../../store/container/AuthContainer";
import { AuthReducerProps } from "../../../store/reducers/authReducer";

interface ReportMacroFormProps extends AuthReducerProps {
  reportMacro: ReportMacro;
  onSuccess: (macro: ReportMacro) => void;
}

function ReportMacroForm({ reportMacro, onSuccess, userRole }: ReportMacroFormProps) {
  const [formLoading, setFormLoading] = useState(false);

  const [formValues] = useState({
    shortname: reportMacro.shortname || "",
    expandedText: reportMacro.expandedText || "",
  });

  const handleSubmit = (values: FormikValues) => {
    const macro = Object.assign(new ReportMacro(), {
      ...reportMacro,
      shortname: values.shortname?.trim(),
      expandedText: values.expandedText?.trim(),
    });

    setFormLoading(true);

        if (macro.id) {
      ReportMacroService.updateReportMacro(
        userRole || UserRoleEnum.ADMIN,
        macro,
        onSuccess,
        () => setFormLoading(false),
        () => setFormLoading(false)
      );
    } else {
      ReportMacroService.createReportMacro(
        userRole || UserRoleEnum.ADMIN,
        macro,
        onSuccess,
        () => setFormLoading(false),
        () => setFormLoading(false)
      );
    }
  };

  return (
    <div className="report-macro-form">
      <h2 className="text-primary">
        {reportMacro.id ? "Edit Macro" : "Add Macro"}
      </h2>
      <p className="text-muted mb-3">
        Type <code>#shortname</code> in the report editor to expand to the full text.
      </p>
      <Formik
        initialValues={formValues}
        onSubmit={handleSubmit}
        enableReinitialize
        validationSchema={reportMacroFormValidation}
      >
        {({ isValid, dirty }) => (
          <Form>
            <Row gutter={[30, 0]}>
              <Col span={12}>
                <InputField
                  title="Shortname"
                  type="text"
                  name="shortname"
                  placeholder="e.g. hc, hep_cyst"
                />
              </Col>
              <Col span={24}>
                <InputField
                  title="Expanded text"
                  type="textarea"
                  name="expandedText"
                  placeholder="e.g. Hepatic Cyst"
                  rows={4}
                />
              </Col>
            </Row>
            <div className="report-macro-form__submit-wrapper text-right mt-3">
              <Button
                type="primary"
                htmlType="submit"
                loading={formLoading}
                disabled={!isValid || !dirty || formLoading}
              >
                {reportMacro?.id ? "Update" : "Add"}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AuthContainer(ReportMacroForm);
